require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-babel-plugin-bucklescript.json") })
        }
      }, "path---package-babel-plugin-bucklescript");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-babel-plugin-bucklescript!./.cache/json/package-babel-plugin-bucklescript.json
// module id = 748
// module chunks = 231608221292675